import { Layers3 } from "lucide-react";

import getInitials from "./LeadOwnersModal/utils";

const avatarColors = [
  "bg-blue-100 text-blue-700",
  "bg-cyan-100 text-cyan-700",
  "bg-emerald-100 text-emerald-700",
  "bg-amber-100 text-amber-700",
];

function avatarClass(seed = "") {
  const score = seed.split("").reduce((sum, character) => sum + character.charCodeAt(0), 0);
  return avatarColors[score % avatarColors.length];
}

export default function OwnerCard({ owner, stages }) {
  const name = owner?.user?.name || "Unnamed owner";
  const email = owner?.user?.email || "No email available";
  const avatarUrl = owner?.user?.avatar_url;
  const stageIds = owner?.stage_ids || [];
  const assignedStageNames = stages
    .filter((stage) => stageIds.includes(stage.id))
    .map((stage) => stage.name);

  return (
    <article className="flex min-w-[250px] flex-1 items-center gap-3 rounded-xl border border-slate-200 bg-slate-50/70 p-3 transition hover:border-blue-200 hover:bg-blue-50/40">
      <div className="relative shrink-0">
        {avatarUrl ? (
          <img src={avatarUrl} alt={name} className="h-10 w-10 rounded-xl object-cover" />
        ) : (
          <div className={`flex h-10 w-10 items-center justify-center rounded-xl text-xs font-bold ${avatarClass(owner?.user?.id || name)}`}>
            {getInitials(name)}
          </div>
        )}
        <span className="absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full border-2 border-white bg-emerald-500" />
      </div>

      <div className="min-w-0 flex-1">
        <h3 className="truncate text-sm font-semibold text-slate-900" title={name}>{name}</h3>
        <p className="truncate text-xs text-slate-500" title={email}>{email}</p>
      </div>

      <div title={assignedStageNames.join(", ") || "No stages assigned"} className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-white px-2.5 py-2 text-xs font-semibold text-slate-600 shadow-sm ring-1 ring-slate-200">
        <Layers3 className="h-3.5 w-3.5 text-blue-600" />
        {stageIds.length}
      </div>
    </article>
  );
}
